import { type MeetingType } from '@module/mdrt-org/shared/utils/enums/meeting-type';
import { type MembershipLevel } from '@module/mdrt-org/shared/utils/enums/membership';

export enum CompanyListingType {
  ANNUAL_MEETING = 'AnnualMeeting',
  APPROVED_MEMBER = 'ApprovedMember',
  EDGE_MEETING = 'EDGEMeeting',
  GLOBAL_CONFERENCE = 'GlobalConference',
  PENDING_MEMBER = 'PendingMember',
}

export type CompanyListingParams = {
  companyId: number;
  listType: CompanyListingType;
  membershipLevel?: MembershipLevel;
  pageNumber?: number;
  pageSize?: number;
  sortAscending?: boolean;
  sortField?: string;
  year: number;
};

export type CompanyListingResult =
  | { data: GetCompanyApprovedMembersResult; listType: CompanyListingType.APPROVED_MEMBER }
  | { data: GetCompanyMeetingRegistrantsResult; listType: CompanyListingType.ANNUAL_MEETING }
  | { data: GetCompanyMeetingRegistrantsResult; listType: CompanyListingType.EDGE_MEETING }
  | { data: GetCompanyMeetingRegistrantsResult; listType: CompanyListingType.GLOBAL_CONFERENCE }
  | { data: GetCompanyPendingMembersResult; listType: CompanyListingType.PENDING_MEMBER };

export type GetCompanyMeetingRegistrantsRequest = BaseCompanyListingRequest & {
  meetingType: MeetingType;
  membershipLevel?: string;
};

export type CompanyMeetingRegistrantDto = {
  addressLine: string;
  agentId: string;
  approvedDate: null | string;
  attendeeStatus: null | string;
  city: string;
  country: string;
  firstName: string;
  lastName: string;
  mdrtId: number;
  membershipLevel: string;
  membershipType: string;
  membershipYearsCount: number;
  phoneNumber: string;
  state: string;
};

export type GetCompanyMeetingRegistrantsResult =
  BaseCompanyListingResult<CompanyMeetingRegistrantDto>;

export type GetCompanyApprovedMembersRequest = BaseCompanyListingRequest & {
  membershipLevel?: string;
};

export type CompanyApprovedMemberDto = {
  addressLine: string;
  agentId: string;
  approvedDate: null | string;
  city: string;
  country: string;
  firstName: string;
  lastName: string;
  mdrtId: number;
  membershipLevel: string;
  membershipType: string;
  membershipYearsCount: number;
  phoneNumber: string;
  state: string;
};

export type GetCompanyApprovedMembersResult = BaseCompanyListingResult<CompanyApprovedMemberDto>;

export type GetCompanyPendingMembersRequest = BaseCompanyListingRequest;

export type CompanyPendingMemberDto = {
  addressLine: string;
  agentId: string;
  city: string;
  country: string;
  firstName: string;
  lastName: string;
  mdrtId: number;
  phoneNumber: string;
  state: string;
  statusId: number;
};

export type GetCompanyPendingMembersResult = BaseCompanyListingResult<CompanyPendingMemberDto>;

type BaseCompanyListingRequest = {
  companyId: number;
  pageNumber?: number;
  pageSize?: number;
  sortAscending?: boolean;
  sortField?: string;
  year: number;
};

type BaseCompanyListingResult<T> = {
  items: T[];
  totalCount: number;
};
